<div class="p-5">
  <drdp-add-edit-table [dataSource]="dataSource" [tableData]="tableData" [columns]="tableColumns"
      viewIcon="uil uil-notes text-drdpblue-300" (viewActionItem)="viewEvidence($event)">
  </drdp-add-edit-table>
</div>